const MOBILE_CUTOFF = 768;

export { MOBILE_CUTOFF };
